// extracted by mini-css-extract-plugin
export default {"ourSolution":"styles_ourSolution__26nF-","threeSteps":"styles_threeSteps__AAcPN"};